import { useQuery } from '@tanstack/react-query'
import { getRequestEventStatistics } from '../../../../apis/dashboard'
import { queryKeys } from '../../../../shared'

/**
 * リクエストイベント統計 Query hook
 *
 * ダッシュボードページで使用する統計データを取得する。
 */
export const useRequestEventStatisticsQuery = () => {
  return useQuery({
    queryKey: queryKeys.statistics.requestEvent(),
    queryFn: async () => {
      const { data } = await getRequestEventStatistics()
      return data
    },
  })
}
